<template>
  <nav class="navbar indigo lighten-1">
    <div class="nav-wrapper">
      <div class="navbar-left">
        <a href="#" @click.prevent="$emit('click')">
          <i class="material-icons white-text">dehaze</i>
        </a>
        <span class="white-text">{{filteredDate}}</span>
      </div>

      <ul class="right">
        <li>
          <a class="dropdown-trigger white-text" href="#" data-target="dropdown" ref="dropdown">
            {{name}}
            <i class="material-icons right">arrow_drop_down</i>
          </a>

          <ul id="dropdown" class="dropdown-content">
            <li @click.prevent="close">
              <router-link to="/profile" class="black-text">
                <i class="material-icons">account_circle</i>
                {{'ProfileTitle' | localize}}
              </router-link>
            </li>
            <li class="divider" tabindex="-1"></li>
            <li>
              <a href="#" class="black-text" @click.prevent="logout">
                <i class="material-icons">assignment_return</i>
                {{'Exit' | localize}}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<style scoped>
#dropdown {
  width: 150px !important;
  top: -65px;
}
</style>

<script>
import dateFilter from "@/filters/date.filter";

export default {
  name: "Navbar",
  data: () => ({
    date: new Date(),
    interval: null,
    dropdown: null,
    width: null,
    filteredDate: null
  }),
  methods: {
    async logout() {
      await this.$store.dispatch("logout");
      this.$router.push("/login?message=logout");
    },

    updateWidth() {
      this.width = window.innerWidth;
    },
    close() {
      this.$emit("closeMenu");
    }
  },
  watch: {
    date() {
      if (this.width > 345 && this.width <= 400) {
        this.filteredDate = dateFilter(this.date, "date");
      } else if (this.width <= 345) {
        this.filteredDate = null;
      } else if (this.width > 400) {
        this.filteredDate = dateFilter(this.date, "datetime");
      }
    }
  },
  computed: {
    name() {
      return this.$store.getters.info.name;
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      this.date = new Date();
    }, 1000);
    this.dropdown = window.M.Dropdown.init(this.$refs.dropdown, {});

    this.width = window.innerWidth;
  },
  created() {
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    if (this.dropdown && this.dropdown.destroy) {
      this.dropdown.destroy();
    }
  }
};
</script>